import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import People from "../../assets/assets/right-web.svg";
import EasySteps from "../../assets/assets/left-easy.svg";
import Icon1 from "../../assets/assets/start-play.svg";
import Icon2 from "../../assets/assets/submit-doc.svg";
import Icon3 from "../../assets/assets/get-access.svg";
import Footer from "../../components/Footer/Footer";

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Navbar />

      <div className="mid-section">
        <div className="about">
          <div className="about-right">
            <div className="about-right-big-text">
              <span>Everything you need to know about</span> <br />
              <span>our APIs; Integration Guidelines,</span> <br />
              <span>API Documentations, Certification</span> <br />
              <span>and Support</span>
            </div>
            <div className="about-right-bottom-section">
              <span>
                We work with all the banking institutions and other financial
                institutions on both payments and collections to give our
                clients value-added services thereby providing the best
                opportunities for their business.
              </span>

              <div className="about-button">
                <Link to="/sign-up">
                  <button>get started</button>
                </Link>
              </div>
            </div>
          </div>

          <div
            data-aos="fade-left"
            data-aos-duration="3000"
            className="about-left"
          >
            <img src={People} alt="images of people" />
          </div>
        </div>

        <div className="landing-mid-section">
          <div className="landing-mid-section-image">
            <img src={EasySteps} alt="easy-steps" />
          </div>

          <div className="easy-steps">
            <div className="easy-steps-header">It’s Super Easy</div>

            <div className="easy-steps-group">
              <div className="number">
                <div className="number-image1">
                  <img src={Icon1} alt="create-account" />
                </div>
              </div>
              <div className="details">
                <p className="title">Create your NIBSS account</p>
                <p className="content">
                  Fill out our quick and easy forms and we will reach out to you
                  if you meet our minimum requirements.
                </p>
              </div>
            </div>

            <div className="easy-steps-group">
              <div className="number">
                <div className="number-image2">
                  <img src={Icon2} alt="submit-doc" />
                </div>
              </div>
              <div className="details">
                <p className="title">Submit all necessary documents</p>
                <p className="content">
                  You will need to submit some documents to be able to access
                  NIBSS products.
                </p>
              </div>
            </div>

            <div className="easy-steps-group">
              <div className="number">
                <div className="number-image3">
                  <img src={Icon3} alt="get-access" />
                </div>
              </div>
              <div className="details">
                <p className="title">Get access to all APIs documentations</p>
                <p className="content">
                  Once you have submitted the required documents and they have
                  been approved, you can now access NIBSS APIs.
                </p>
              </div>
            </div>
          </div>
        </div>

        <section className="mid-footer">
          <div className="mid-footer-note">
            This information does not take your circumstances into account. Read
            the relevant Product Disclosure Statements or other disclosure
            documents before making a decision. Unless otherwise specified, the
            products and services described on this website are available only
            in Nigeria from Nigeria Inter-Bank Settlement System.{" "}
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;
